import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const reviews = [{
  name: 'Michael Thompson',
  review: "Best cut I've ever had. The attention to detail is unmatched.",
  rating: 5
}, {
  name: 'James Anderson',
  review: 'Professional service, premium experience. Worth every penny.',
  rating: 5
}, {
  name: 'Robert Martinez',
  review: 'These guys are artists. My fade is absolutely perfect.',
  rating: 5
}, {
  name: 'David Chen',
  review: 'The atmosphere is incredible. Feels like a luxury experience.',
  rating: 5
}, {
  name: 'William Brown',
  review: 'Been coming here for months. Consistently excellent work.',
  rating: 5
}];
export function Reviews() {
  return <section id="reviews" className="py-32 px-6 bg-gradient-to-b from-deep-green/10 to-matte-black overflow-hidden" data-id="element-176">
      <style data-id="element-177">
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            animation: marquee 40s linear infinite;
          }
          .animate-marquee:hover {
            animation-play-state: paused;
          }
        `}
      </style>
      <div className="max-w-7xl mx-auto mb-20" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-179">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-off-white mb-4" data-id="element-180">
            Client Reviews
          </h2>
          <p className="font-inter text-lg text-off-white/60" data-id="element-181">
            Trusted by discerning gentlemen
          </p>
        </motion.div>
      </div>

      <div className="flex overflow-hidden" data-id="element-182">
        <div className="flex gap-6 animate-marquee w-max" data-id="element-183">
          {/* Duplicate reviews 3 times for seamless loop */}
          {[...reviews, ...reviews, ...reviews].map((review, index) => <div key={index} className="flex-shrink-0 w-[350px] p-8 rounded-2xl bg-off-white/5 backdrop-blur-md border border-off-white/10" data-id="element-184">
              <div className="flex gap-1 mb-4" data-id="element-185">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="text-soft-gold fill-soft-gold" size={20} data-id="element-186" />)}
              </div>

              <p className="font-inter text-off-white/90 text-lg mb-6 leading-relaxed" data-id="element-187">
                "{review.review}"
              </p>

              <div className="font-inter text-soft-gold font-semibold" data-id="element-188">
                {review.name}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}